import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ISkill, ISkillForm } from "../models/skills";

@Injectable({
  providedIn: "root",
})
export class SkillsService {
  public list: ISkill[] = [];
  public list_enabled: ISkill[] = [];
  public baseurl: string = "/skill";

  constructor(private _httpClient: HttpClient) {}

  async getList(force: boolean = false) {
    if (this.list.length > 0 && force) return this.list;

    return this._httpClient
      .get<ISkill[]>("/skill?enabled=2")
      .toPromise()
      .then((response: ISkill[]) => {
        this.list = response;
        this.list_enabled = response.filter((skill: ISkill) => skill.enabled === 1);
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async create(data: ISkillForm) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: ISkillForm) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async approve(id: number) {
    return this._httpClient
      .put(`/skill/${id}/approve`, {})
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async reject(id: number) {
    return this._httpClient
      .put(`/skill/${id}/reject`, {})
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }
}
